export default "__VITE_ASSET__Dut8rnIh__"